/*
 * Copyright (c) 2018 Honeywell International Inc. All Rights Reserved.
 * Honeywell and its product names are among the trademarks and/or service marks owned by Honeywell International, Inc., or its subsidiaries.
 *
 * For patent information, see http://www.hsmpats.com.
 */

import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { AppConsumer } from '@keystone/common';

/**
 * This component will protect all routes in which a user should have to be logged in, in order to view
 */

const PrivateRoute = ({ component: Component, ...rest }) => (
  <AppConsumer>
    {(appContext) => (
      <Route
        {...rest}
        render={(props) =>
          appContext.isAuthenticated ? <Component {...props} /> : <Redirect to="/login" />
        }
      />
    )}
  </AppConsumer>
);

export default PrivateRoute;
